/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import client1 from "../assets/images/clients/client1.png";
import client2 from "../assets/images/clients/client2.png";
import client3 from "../assets/images/clients/client3.png";
import client4 from "../assets/images/clients/client4.png";
import client5 from "../assets/images/clients/client5.png";
import client6 from "../assets/images/clients/client6.png";
import client7 from "../assets/images/clients/client7.png";
import client8 from "../assets/images/clients/client8.png";
import client9 from "../assets/images/clients/client9.png";
import client10 from "../assets/images/clients/client10.png";
import client11 from "../assets/images/clients/client11.png";
import client12 from "../assets/images/clients/client12.png";
import client13 from "../assets/images/clients/client13.png";
import client14 from "../assets/images/clients/client14.png";
import client15 from "../assets/images/clients/client15.png";
import client16 from "../assets/images/clients/client16.png";
import client17 from "../assets/images/clients/client17.png";
import "./Clients.css";
import { Fade } from "react-reveal";

export default function Clients() {
  return (
    <div className="clientsSec" id="clients">
      <div className="bgColor container-fluid">
        <Fade bottom>
          <div className="clientsCard">
            <h3>عملاؤنا</h3>
            <ul>
              <li style={{ backgroundImage: `url(${client1})` }}></li>
              <li style={{ backgroundImage: `url(${client2})` }}></li>
              <li style={{ backgroundImage: `url(${client3})` }}></li>
              <li style={{ backgroundImage: `url(${client4})` }}></li>
              <li style={{ backgroundImage: `url(${client5})` }}></li>
              <li style={{ backgroundImage: `url(${client6})` }}></li>
              <li style={{ backgroundImage: `url(${client7})` }}></li>
              <li style={{ backgroundImage: `url(${client8})` }}></li>
              <li style={{ backgroundImage: `url(${client9})` }}></li>
              <li style={{ backgroundImage: `url(${client10})` }}></li>
              <li style={{ backgroundImage: `url(${client11})` }}></li>
              <li style={{ backgroundImage: `url(${client12})` }}></li>
              <li style={{ backgroundImage: `url(${client13})` }}></li>
              <li style={{ backgroundImage: `url(${client14})` }}></li>
              <li style={{ backgroundImage: `url(${client15})` }}></li>
              <li style={{ backgroundImage: `url(${client16})` }}></li>
              <li style={{ backgroundImage: `url(${client17})` }}></li>
            </ul>
          </div>
        </Fade>
      </div>
    </div>
  );
}
